import { render, staticRenderFns } from "./BasedAnotherStandardMethod.vue?vue&type=template&id=1bf4d82c&scoped=true&"
import script from "./BasedAnotherStandardMethod.vue?vue&type=script&lang=js&"
export * from "./BasedAnotherStandardMethod.vue?vue&type=script&lang=js&"
import style0 from "./BasedAnotherStandardMethod.vue?vue&type=style&index=0&id=1bf4d82c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf4d82c",
  null
  
)

export default component.exports